import { GraphNode } from '../graph-node.js';
const FLOW_EXEC_OUT_PORT_KEYS = new Set([
    'exec',
    'completed',
    'a',
    'b',
    'body'
]);
function normalizeCount(value, fallback = 0) {
    const count = Number(value);
    if (!Number.isFinite(count))
        return fallback;
    return Math.max(0, Math.floor(count));
}
class FlowControlNode extends GraphNode {
    isExecOutPort(outPortKey) {
        if (FLOW_EXEC_OUT_PORT_KEYS.has(outPortKey))
            return true;
        return super.isExecOutPort(outPortKey);
    }
}
export class DoOnceNode extends FlowControlNode {
    hasInitialized = false;
    isClosed = false;
    async run() {
        super.run();
        if (!this.hasInitialized) {
            this.isClosed = this.data.startClosed === true;
            this.hasInitialized = true;
        }
        if (this.enteredExecInPortKey === 'reset') {
            this.isClosed = false;
            return;
        }
        if (this.isClosed)
            return;
        this.isClosed = true;
        await this.runOutPort('exec');
    }
}
export class DoNNode extends FlowControlNode {
    executionCount = 0;
    async run() {
        super.run();
        if (this.enteredExecInPortKey === 'reset') {
            this.executionCount = 0;
            return;
        }
        const limit = normalizeCount(this.data.n, 1);
        if (this.executionCount >= limit) {
            await this.runOutPort('completed');
            return;
        }
        this.executionCount += 1;
        await this.runOutPort('exec');
        if (this.executionCount === limit) {
            await this.runOutPort('completed');
        }
    }
}
export class FlipFlopNode extends FlowControlNode {
    shouldRunA = true;
    async run() {
        super.run();
        const outputKey = this.shouldRunA ? 'a' : 'b';
        this.data.isA = this.shouldRunA;
        this.shouldRunA = !this.shouldRunA;
        await this.runOutPort(outputKey);
    }
}
export class GateNode extends FlowControlNode {
    isInitialized = false;
    isOpen = true;
    async run() {
        super.run();
        this.initializeState();
        if (this.enteredExecInPortKey === 'open') {
            this.isOpen = true;
            return;
        }
        if (this.enteredExecInPortKey === 'close') {
            this.isOpen = false;
            return;
        }
        if (this.enteredExecInPortKey === 'toggle') {
            this.isOpen = !this.isOpen;
            return;
        }
        if (!this.isOpen)
            return;
        await this.runOutPort('exec');
    }
    initializeState() {
        if (this.isInitialized)
            return;
        this.isOpen = this.data.startClosed !== true;
        this.isInitialized = true;
    }
}
export class WhileLoopNode extends FlowControlNode {
    async run() {
        super.run();
        const maximumIterations = normalizeCount(this.data.maxIterations, 1000);
        for (let index = 0; index < maximumIterations; index += 1) {
            this.getDataFromInPorts();
            if (this.data.condition !== true)
                break;
            this.data.index = index;
            await this.runOutPort('body');
        }
        await this.runOutPort('completed');
    }
}
export class ForLoopWithBreakNode extends FlowControlNode {
    shouldBreak = false;
    async run() {
        super.run();
        if (this.enteredExecInPortKey === 'break') {
            this.shouldBreak = true;
            return;
        }
        this.shouldBreak = false;
        const firstIndex = Math.floor(Number(this.data.first) || 0);
        const lastIndex = Math.floor(Number(this.data.last) || 0);
        for (let index = firstIndex; index <= lastIndex; index += 1) {
            if (this.shouldBreak)
                break;
            this.data.index = index;
            await this.runOutPort('body');
        }
        await this.runOutPort('completed');
    }
}
